import state from "@/store/log/state";
import mutations from "@/store/log/mutations";
import actions from "@/store/log/actions";

export default {
  state,
  mutations,
  actions,
};
